import {useContext, useMemo} from 'react';
import {Lenders} from "../LendersProvider";
import {ApplicationTypes, MortgageTypes} from "../../../models";
function calcPMT(rate, nperiod, pv, fv, type) {
    if (!fv) {
        fv = 0;
    }
    if (!type) {
        type = 0;
    }
    if (rate === 0) {
        return -(pv + fv) / nperiod;
    }
    var pvif = Math.pow(1 + rate, nperiod);
    var pmt = rate / (pvif - 1) * -(pv * pvif + fv);
    if (type === 1) {
        pmt /= 1 + rate;
    }
    return pmt;
}

export function calcMonthlyPayment(required, term, rate) {
    let trueRate = parseFloat(rate) / 100 / 12;
    const pmt = calcPMT(trueRate, term * 12, required) * -1;
    return Math.round(pmt);
}
function useRates() {
    const {lenders, allRates} = useContext(Lenders)



    function ltv(loan, value) {
        // to 1 dec place
        return Math.round((loan / value) * 100 * 10) / 10
    }
    const addPromotionsToRates = (rates, {
        loan,
        switcher,
        term
    }) => {

        return rates.map(item => {
            // add offers to rates
            switch (item.lenderCode) {
                case 'avant':
                    if (!item.product.includes('Flex') && !item.product.includes('High Value Mortgage')) {
                        if (loan < 1000000) {
                            const cashbackPercent = item.term <= 10 ? 2 : 1
                            const cashbackValue = loan * (cashbackPercent / 100)
                            item.offers = {
                                cashback: {
                                    name: 'Cashback',
                                    label: 'Cashback',
                                    value: cashbackValue,
                                    description: `The product you have selected qualifies for  ${cashbackPercent}% of Loan Cashback on Drawdown.`
                                }
                            }
                        }
                    }
                    break
                case 'haven':
                    let fiveGrandUnavailable = loan < 250000 || item.term === 0
                    if (switcher) {
                        item.offers = {
                            cashback: {
                                name: 'Cashback',
                                title: `${fiveGrandUnavailable ? (3000).toEuro() : (5000).toEuro()} Cashback on Drawdown`,
                                value: fiveGrandUnavailable ? 3000 : 5000,
                                description: `The product you have selected qualifies for ${fiveGrandUnavailable ? (3000).toEuro() : (5000).toEuro()} Cashback on Drawdown.`
                            }
                        }
                    }
                    else {
                        if (!fiveGrandUnavailable) {
                            item.offers = {
                                cashback: {
                                    name: 'Cashback',
                                    title: '€5000 Cashback on Drawdown',
                                    value: 5000,
                                    description: `The product you have selected qualifies for ${(5000).toEuro()} Cashback on Drawdown.`
                                }
                            }
                        }
                    }
                    break
                case 'ptsb':
                    item.offers = {
                        monthlyCashback: {
                            name: 'Monthly Cashback',
                            title: '2% Cashback on monthly Mortgage Repayments from PTSB Explore Account',
                            value: Math.round(calcMonthlyPayment(loan, term, item.rate) * 0.02),
                            description: 'You will be making your mortgage repayments from a PTSB Explore Account so will qualify for 2% monthly cashback on your mortgage repayments. '
                        }
                    }
                    if (!item.product.includes('4 Year Fixed Rate New Business')) {
                        item.offers.cashback = {
                            name: 'Cashback',
                            title: '2% of Loan Cashback on Drawdown',
                            value: loan * 0.02,
                            description: 'The product you have selected qualifies for 2% cashback on drawdown.'
                        }
                    }
                    break
                case 'boi':
                    if (!item.product.includes('HVM') && !!item.term) {
                        item.offers = {
                            cashback        : {
                                name       : 'Cashback',
                                label      : 'Cashback',
                                value      : loan * 0.02,
                                description: 'The product you have selected qualifies for 2% of Loan Cashback on Drawdown.'
                            },
                            cashbackIn5Years: {
                                name       : 'CashbackIn5Years',
                                label      : 'Cashback in 5 years',
                                value      : loan * 0.01,
                                description: 'The product you have selected qualifies for 1% of Loan Cashback 5 Years after Drawdown.'
                            }
                        }
                    }
                    break
            }
            return item
        })

    }
    const newApprovedRates = (newRates, propertyValue, loanRequired, loanTerm, ber, buyToLet=false) => {
        if (!newRates || !propertyValue || !loanRequired || !loanTerm) {
            return []
        }
        let green = !!ber ? ber?.startsWith('A') || ber?.startsWith('B') : false
        const myLTV = ltv(loanRequired, propertyValue)
        let lastError = false

        const r = newRates.filter(item => {
            if (!!item?.buyToLet && !buyToLet) {
                lastError = 'BTL only'
                return false
            }
            if (!item.buyToLet && buyToLet) {
                lastError = 'Not BTL'
                return false
            }
            if (myLTV > item.maxLTV) {

                lastError = 'Try decreasing the loan amount'

                return false
            }
            if (item?.minimum && item.minimum > loanRequired) {

                lastError = 'Try increasing the loan amount'

                return false
            }
            if (item?.maximum && item.maximum < loanRequired) {
                lastError = 'Try reducing the loan amount'

                return false
            }
            if (item?.minTerm && item.minTerm > loanTerm) {
                lastError = 'Try increasing the loan term'

                return false
            }
            if (item?.maxTerm && item.maxTerm < loanTerm) {
                lastError = 'Try decreasing the loan term'

                return false
            }
            if (!green && item.conditions && (item.conditions.includes('BER B3 or better required') || item.conditions.includes('Green'))) {

                return false
            }


            if (item.minBER){ // BOI for now
                const bers = ["A","B","C","D","E","F","G"]
                const minIndex = bers.indexOf(item.minBER[0].toUpperCase())

                if (!ber || bers.indexOf(ber[0].toUpperCase()) > minIndex) {
                    return false
                }
            }
            if (item.lenderCode === 'avant' && item.product?.includes('One Mortgage') && (loanTerm > item.term || loanTerm + 5 <= item.term)){
                return false
            }

            return true
        })

        if (!r.length > 0) {

            return {error: lastError}
        }
        // remove ltv matches that are higher than the lowest ltv match

        const objectified = {}
        r.forEach(item => {
            if (!objectified.hasOwnProperty(item.lenderCode)) {
                objectified[item.lenderCode] = {}
            }
            if (!objectified[item.lenderCode].hasOwnProperty(item.term)) {
                objectified[item.lenderCode][item.term] = []
            }
            objectified[item.lenderCode][item.term].push(item)
        })
        // filter out any results whose ltv is higher than the lowest unless the rate it better  in all lender/term combinations
        let revised = []

        Object.keys(objectified).forEach(lender => {
            Object.keys(objectified[lender]).forEach(term => {


                //first sort array by lowest rate at top and then by lowest ltv
                objectified[lender][term].sort((a, b) => {
                    if (a.rate === b.rate) {
                        return a.maxLTV - b.maxLTV
                    }
                    return a.rate - b.rate
                })

                revised.push(...objectified[lender][term])
                //get the rate of lowest ltv and exclude any rates not as good from the same lender
                // let lowestRate = objectified[lender][term].reduce((prev, curr) => {
                //     if (prev.rate === curr.rate) {
                //         return prev.maxLTV < curr.maxLTV ? prev : curr
                //     }
                //     return prev.rate < curr.rate ? prev : curr
                // })
                // revised.push(lowestRate)
            })
        })

        return revised

        //return r.length > 0 ? r : {error: lastError}
    }
    const getApprovedRates = (rates, propertyValue, loanRequired, loanTerm, green) => {
        if (!rates) {
            return []
        }
        const myLTV = ltv(loanRequired, propertyValue)

        let lastError = false


        const r = rates.filter(item => {
            if (!!item?.buyToLet) {
                lastError = 'BTL only'
                return false
            }
            if (myLTV > item.maxLTV) {

                lastError = 'Try decreasing the loan amount'

                return false
            }
            if (item?.minimum && item.minimum > loanRequired) {

                lastError = 'Try increasing the loan amount'

                return false
            }
            if (item?.maximum && item.maximum < loanRequired) {
                lastError = 'Try reducing the loan amount'

                return false
            }
            if (item?.minTerm && item.minTerm > loanTerm) {
                lastError = 'Try increasing the loan term'

                return false
            }
            if (item?.maxTerm && item.maxTerm < loanTerm) {
                lastError = 'Try decreasing the loan term'

                return false
            }
            if (!green && item.conditions && (item.conditions.includes('BER B3 or better required') || item.conditions.includes('Green'))) {

                return false
            }

            return true
        })

        if (!r.length > 0) {

            return {error: lastError}
        }
        // remove ltv matches that are higher than the lowest ltv match

        const objectified = {}
        r.forEach(item => {
            if (!objectified.hasOwnProperty(item.lenderCode)) {
                objectified[item.lenderCode] = {}
            }
            if (!objectified[item.lenderCode].hasOwnProperty(item.term)) {
                objectified[item.lenderCode][item.term] = []
            }
            objectified[item.lenderCode][item.term].push(item)
        })
        // filter out any results whose ltv is higher than the lowest unless the rate it better  in all lender/term combinations
        let revised = []

        Object.keys(objectified).forEach(lender => {
            Object.keys(objectified[lender]).forEach(term => {


                //first sort array by lowest rate at top and then by lowest ltv
                objectified[lender][term].sort((a, b) => {
                    if (a.rate === b.rate) {
                        return a.maxLTV - b.maxLTV
                    }
                    return a.rate - b.rate
                })


                //get the rate of lowest ltv and exclude any rates not as good from the same lender
                let lowestRate = objectified[lender][term].reduce((prev, curr) => {
                    if (prev.rate === curr.rate) {
                        return prev.maxLTV < curr.maxLTV ? prev : curr
                    }
                    return prev.rate < curr.rate ? prev : curr
                })
                revised.push(lowestRate)
            })
        })


        return revised

        //return r.length > 0 ? r : {error: lastError}
    }
    const bestWithAndWithoutPromotions = (rates) => {
        let Map = {}
        if (rates){
            rates.forEach(rate=>{
                if (!Map.hasOwnProperty(rate.lenderCode)){
                    Map[rate.lenderCode] = {}
                }
                if (!Map[rate.lenderCode].hasOwnProperty(rate.term)){
                    Map[rate.lenderCode][rate.term] = {
                        withPromotions: [],
                        withoutPromotions: []
                    }
                }
                if (!rate.offers){
                    Map[rate.lenderCode][rate.term].withoutPromotions.push(rate)
                }
                else {
                    Map[rate.lenderCode][rate.term].withPromotions.push(rate)
                }
            })
        }
        let Result = []
        Object.keys(Map).forEach(lender=>{
            Object.keys(Map[lender]).forEach(term=>{
                let withPromotions = Map[lender][term].withPromotions.sort((a, b) => {
                    if (a.rate === b.rate) {
                        return a.maxLTV - b.maxLTV
                    }
                    return a.rate - b.rate
                })
                let withoutPromotions = Map[lender][term].withoutPromotions.sort((a, b) => {
                    if (a.rate === b.rate) {
                        return a.maxLTV - b.maxLTV
                    }
                    return a.rate - b.rate
                })
                if (withoutPromotions.length){
                    //Result.push(withoutPromotions[0])
                    Result.push(...withoutPromotions)
                }
                if (withPromotions.length){
                   // Result.push(withPromotions[0])
                    Result.push(...withPromotions)
                }
            })
        })
        return Result
    }
    const getProductsForMortgage = (mortgage) => {
        const property = mortgage.property || mortgage.properties[0]
        if (!property){
            return []
        }
        let lender = mortgage?.activeSubmission?.lenderCode ? mortgage.activeSubmission?.lenderCode : mortgage.requirement.lenderCode
        let figures = mortgage?.activeSubmission?.verifiedFiguresTest?.test?.figures ? JSON.parse(mortgage?.activeSubmission?.verifiedFiguresTest?.test?.figures) : null
        if (!figures){
             figures = mortgage?.activeSubmission?.provisionalXlsInput?.figures
        }

        let propertyValue = figures ? figures.provisionalValue ?? figures.propertyValue : mortgage.property.propertyPrice || mortgage.properties[0]?.propertyValue
        let loanRequired = figures ? figures.provisionalLoan ?? figures.loanRequired : mortgage.activeSubmission?.finalLoan || mortgage.activeSubmission?.aipMaxLoan || mortgage.activeSubmission?.provisionalLoan || mortgage.requirement.loanRequired
        let loanTerm = figures ? figures.provisionalTerm ?? figures.termRequired  : mortgage.activeSubmission?.finalTerm || mortgage.activeSubmission?.aipTerm || mortgage.activeSubmission?.provisionalTerm ||  mortgage.requirement.loanTerm


        let ber = mortgage.properties[0]?.berScore
        let green = ber && (ber.startsWith('A') || ber.startsWith('B'))

        let rates = lenders.find(lr=>lr.lenderCode === lender)?.rates
        const buyToLet = mortgage.mortgageType === MortgageTypes.PURCHASE && mortgage.applicationType === ApplicationTypes.LANDLORD

        return getProducts({loan: loanRequired, term: loanTerm, value: propertyValue, lender, switcher: mortgage.mortgageType === MortgageTypes.REFINANCE, ber, buyToLet})
    }
    const getProducts = ({loan, term, value, lender, switcher, ber, buyToLet}) => {

        let rates = lenders.find(lr=>lr.lenderCode === lender)?.rates
        let approvedRates = newApprovedRates(rates, value, loan, term, ber, buyToLet)
        if (approvedRates.error) {
            return {error: approvedRates.error}
        }

        return bestWithAndWithoutPromotions(addPromotionsToRates(approvedRates, {loan, switcher, term}))
    }

    if (!lenders.length) {
        return {
            getProductsForMortgage: () => [],
            getProducts: () => []
        }
    }
    return {
        getProductsForMortgage,
        getProducts,
        allRates
    }
}

export default useRates;